module.exports = __webpack_public_path__ + "static/media/10.e42c0e4c.png";